module.exports = {
  URLS: {
    i5Scheduler: "https://nyc-scheduler.incus5.com/calendar/v1.0/",
    tokenService: "https://nyc-scheduler.incus5.com/authentication/v1.0/token",
    userManagement: "https://nyc-scheduler.incus5.com/user/v1.0/",
  },
  syncevent: {
    eventId: "25bcc807-747d-458c-9d2f-955184ca7087",
    eventIdPl: "9701299a-9171-4e1a-a845-5327d24eb589",
  },
  eventyTypesList: [
    {
      title: "One on One",
      eventId: 1,
    },
    {
      title: "Round Robin",
      eventId: 2,
    },
  ],
  loginConfig:
    "client_id=CE262E17-16BD-4E6A-AB30-94115ABFDE2B&grant_type=password",
  MICROSOFT: {
    loginRequestScopes: {
      scopes: ["openid", "profile", "User.Read"]
    },
    graphConfig: {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
      graphProfilePicEndPointExternal:
        "https://graph.microsoft.com/beta/users/UserIdOrPrincipalName/photo/$value",
      graphProfilePicEndPointInternal:
        "https://graph.microsoft.com/v1.0/me/photo/$value"
    },
    MSAuthConfig: {
      auth: {
        clientId: "16555a95-775b-4d2e-8e9e-6ffb91c78522", //You will need to change this
        authority: "https://login.microsoftonline.com/common",
        redirectUri: "https://nyc-scheduler-admin.incus5.com/" //You will need to change this
        // "http://localhost:80/"
        // https://dev-gse.incus5.com/
      }
    }
  }
};
